<template>

	<footer dark id="footer-ticket" class="d-flex flex-column mt-lg-0 mt-n1">
		<v-container class="px-0">
			<v-row cols="12" class="d-flex justify-content-between flex-wrap">
				<!-- Columna 1 Logo -->
				<v-col cols="12" md="4">
					<router-link :to="{ path: '/' }" class="navbar-brand d-block" title="TicketShop" tag="a">
						<v-img class="mb-5" src="../../../public/images/logo-dark.svg" max-width="75"></v-img>
					</router-link>
					<span class="outlineVariant--text body-2">
						La mejor solución de boletería en línea 🎟️ para los
						grandes eventos.
					</span>
				</v-col>
				<!-- Column 2 TicketShop-->

				<v-col cols="6" md="4" class="mx-0 px-0">


					<v-btn text dark disabled>
						<v-text class="tertiaryFixedDim--text font-weight-bold">
							TicketShop
						</v-text>
					</v-btn>




					<ul class="pl-0 m-0 list-unstyled list-menu-links inverseOnSurface--text body-2">
						<li>
							<router-link class="inverseOnSurface--text" :to="{
								path: '/terminoscondiciones',
							}" title="Terminos y Condiciones">
								<v-btn dark text>
									Terminos y Condiciones
								</v-btn>
							</router-link>
						</li>
						<li>
							<router-link class="inverseOnSurface--text" :to="{
								path: '/politicatratamiento',
							}" title="Politica de tratamiento de proteccion de datos personales">
								<v-btn dark text class="d-flex flex-wrap ">
									Política de Privacidad
								</v-btn>
							</router-link>
						</li>
						<li>


							<v-btn dark text>
								<a class="inverseOnSurface--text" href="https://centrodeayuda.ticketshop.com.co"
									title="Peticiones, Quejas y Reclamos">
									PQR
								</a>
							</v-btn>

						</li>
						<li>
							<v-btn dark text>

								<a class="inverseOnSurface--text" href="https://www.sic.gov.co/asesoria-en-linea">

									SIC

								</a>
							</v-btn>

						</li>
					</ul>

				</v-col>

				<!-- Columna 3 Quienes Somos -->
				<v-col cols="6" md="2" class="mx-0 px-0">


					<v-btn text dark disabled>
						<v-text class="tertiaryFixedDim--text font-weight-bold">
							Quienes somos
						</v-text>
					</v-btn>


					<ul class="p-0 m-0 list-unstyled list-menu-links inverseOnSurface--text body-2">

						<li>
							<router-link class="inverseOnSurface--text" :to="{ path: '/mision' }" title="Mision">
								<v-btn dark text>
									Mision y Visión
								</v-btn>
							</router-link>
						</li>

						<li>
							<router-link class="inverseOnSurface--text" :to="{ path: '/comunicados' }" title="Comunicados">
								<v-btn dark text class="justify-start">
									Comunicados
								</v-btn>
							</router-link>
						</li>
						<li>
							<router-link class="inverseOnSurface--text" :to="{ path: '/puntosVenta' }" title="PUNTOS DE VENTA">
								<v-btn dark text>
									Puntos de Venta
								</v-btn>
							</router-link>
						</li>
					</ul>


				</v-col>
				<v-spacer></v-spacer>


			</v-row>
		</v-container>
		<!-- Derechos y Redes Sociales -->

		<!-- Derechos -->
		<v-container class="mt-0 pt-0">
			<v-row cols="12" class="d-flex flex-column justify-content-sm-start flex-md-row pt-0 my-md-12 mt-0">
				<v-col md="8" cols="12" max-height="32"
					class="outlineVariant--text mr-0 align-center d-flex order-2 order-md-first p-0">
					<v-card-text class="p-0">
						@ {{ new Date().getFullYear() }} Ticket Shop
						Colombia. Todos los derechos reservados
					</v-card-text>
				</v-col>
				<v-spacer></v-spacer>
				<!-- Redes Sociales -->

				<v-col cols="6" md="3" row class="d-flex order-1 flex-grow-1 px-0 ">
					<v-col class="ml-n4">
						<a href="https://www.facebook.com/TICKETSHOPCOL/" target="_blank" aria-label="Síguenos en Facebook">
							<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512">
								<!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
								<path fill="#CAC5CB"
									d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z" />
							</svg>
						</a>
					</v-col>
					<v-col>
						<a href="https://twitter.com/TicketShopCol" target="_blank" aria-label="Síguenos en Twitter">
							<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512">
								<!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
								<path fill="#CAC5CB"
									d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
							</svg>
						</a>
					</v-col>
					<v-col>
						<a href="https://www.instagram.com/ticketshopcol/" target="_blank" aria-label="Síguenos en Instagram">
							<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512">
								<!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
								<path fill="#CAC5CB"
									d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
							</svg>
						</a>
					</v-col>
					<v-col>
						<a href="https://www.youtube.com/channel/UCmYdWEN9mbjAR27TuP9gEwg" target="_blank"
							aria-label="Síguenos en Youtube">
							<svg xmlns="http://www.w3.org/2000/svg" height="24" width="28" viewBox="0 0 575 512">
								<!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
								<path fill="#CAC5CB"
									d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
							</svg>
						</a>
					</v-col>
				</v-col>
				
			</v-row>
		</v-container>

	</footer>

</template>
<script>
import axios from "axios";
import { configApi } from "../../api/configApi";
import { headers } from "../../api/headers";
export default {
	mounted() { },
	async beforeCreate() {
		await axios
			.get(`${configApi.apiUrl}buscarimagenaliados`, null, {
				headers: headers,
			})
			.then((response) => {
				this.ftaliados = response.data.data;

				this.aliados = this.ftaliados.map((item) => {
					return { src: item.url };
				});

				this.cssRefresh = true;

				$(document).ready(function () {
					$(".aliados").slick({
						slidesToShow: 6,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 3000,
						arrows: false,
						dots: false,
						vertical: false,
						pauseOnHover: false,
						responsive: [
							{
								breakpoint: 768,
								settings: {
									slidesToShow: 4,
								},
							},
							{
								breakpoint: 520,
								settings: {
									slidesToShow: 3,
								},
							},
						],
						variableWidth: true,
					});
				});
			});
	},
	data() {
		return {
			aliados: [],
			ftaliados: [],
			cssRefresh: false,
		};
	},
};
</script>
<style scoped>
a:hover {
	color: #FFE176 !important;
	filter: brightness(1.1);
}

svg:hover {
	filter: brightness(1.75);
}
</style>
